goog.provide('el8.practicedata.rxRefillRequests');

goog.require('el8.ptdata.rxRefillRequests');


el8.practicedata.rxRefillRequests = el8.ptdata.rxRefillRequests;

